import { useEffect, useState } from "react";
import "./index.scss";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import store from "store";
import { Actions as ApiCallActions } from "../../../redux/apiCall/reducers";
import { Actions as AuthActions } from "../../../redux/auth/reducers";
// import { ServiceTypeEnum } from "../../../utils/enums";
import Input from "../../../components/input";
import { ValidationPatterns, ValidationMessages } from "../../../utils/validation";
import LanguageSwitcher from "../../../components/language-switcher";
import useI18n from "../../../i18n/useI18n";

const assetStylesheets = [
  "/assets/plugins/bootstrap/css/bootstrap.min.css",
  "/assets/css/main.css",
  "/assets/css/authentication.css",
  "/assets/css/color_skins.css",
];

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useI18n();
  // CSS'ler route helper tarafından yönetiliyor, burada sadece yüklendiğinden emin oluyoruz
  useEffect(() => {
    assetStylesheets.forEach((href) => {
      const existing = document.querySelector(`link[href="${href}"]`);
      if (!existing) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        document.head.appendChild(link);
      }
    });
  }, []);

  const [navOpen, setNavOpen] = useState(false);
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const html = document.documentElement;
    if (navOpen) {
      html.classList.add("nav-open");
    } else {
      html.classList.remove("nav-open");
    }
    return () => html.classList.remove("nav-open");
  }, [navOpen]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCredentials((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleValidationChange = (fieldName, isValid, errorMessage) => {
    setValidationErrors((prev) => ({
      ...prev,
      [fieldName]: isValid ? "" : errorMessage,
    }));

    // Form geçerliliğini kontrol et
    const updatedErrors = {
      ...validationErrors,
      [fieldName]: isValid ? "" : errorMessage,
    };
    const formIsValid = Object.values(updatedErrors).every((error) => error === "");
    setIsFormValid(formIsValid);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    handleSubmitLogin();
  };

  const handleSubmitLogin = () => {
    // Form validation kontrolü
    if (!isFormValid) {
      return;
    }

    console.log("handleSubmitLogin", credentials);
    dispatch(
      ApiCallActions.Post({
        url: "auth/login",
        // serviceType: ServiceTypeEnum.Auth,
        data: credentials,
        showAlertOnError: true,
        showLoading: true,
        onSuccess: async ({ data }) => {
          // Handle new token structure: data.data.tokens.accessToken
          // Also support: data.tokens (if response is unwrapped) or data.token (old format)
          const tokens = data?.data?.tokens || data?.tokens;
          if (tokens && tokens.accessToken) {
            // New format: store both accessToken and refreshToken
            store.set("token", tokens.accessToken);
            if (tokens.refreshToken) {
              store.set("refreshToken", tokens.refreshToken);
            }
            if (tokens.expiresAt) {
              store.set("tokenExpiresAt", tokens.expiresAt);
            }
            
            // Profil bilgilerini çek ve store'a kaydet
            dispatch(
              ApiCallActions.Get({
                url: 'auth/profile',
                showAlertOnError: false,
                showLoading: false,
                onSuccess: ({ data }) => {
                  const profileData = data?.data || data;
                  console.log("dataif", profileData);
                  // userInfo'yu localStorage'a kaydet
                  store.set("userInfo", profileData);
                  dispatch(AuthActions.setAuthState({
                    userInfo: profileData,
                    isUserAuthorized: true
                  }));
                  // Sayfa yenileme yerine navigate kullan
                  navigate("/");
                },
                onError: () => {
                  // Profil çekilemese bile login devam etsin
                  console.error('Profile fetch error');
                }
              })
            );
          } else if (data?.token) {
            // Old format: backward compatibility
            store.set("token", data.token);
            
            // Profil bilgilerini çek ve store'a kaydet
            dispatch(
              ApiCallActions.Get({
                url: 'auth/profile',
                showAlertOnError: false,
                showLoading: false,
                onSuccess: ({ data }) => {
                  console.log("dataelse", data);
                  const profileData = data?.data || data;
                  // userInfo'yu localStorage'a kaydet
                  store.set("userInfo", profileData);
                  dispatch(AuthActions.setAuthState({
                    userInfo: profileData,
                    isUserAuthorized: true
                  }));
                  // Sayfa yenileme yerine navigate kullan
                  navigate("/");
                },
                onError: () => {
                  // Profil çekilemese bile login devam etsin
                  console.error('Profile fetch error');
                }
              })
            );
          } else {
            // Token yoksa bile navigate et (hata durumunda)
            navigate("/");
          }
        },
        // callback: () => setLoading(false),
      })
    );
  };


  return (
    <section className="theme-orange authentication sidebar-collapse">
      <nav className="navbar navbar-expand-lg fixed-top navbar-transparent">
        <div className="container" style={{justifyContent:'flex-end',marginRight:15}}>
         
          <div>
            <ul className="navbar-nav navbar-flex-row">
              <li className="nav-item">
                <a className="nav-link" href="https://www.yosdanismanim.com/" target="_blank" rel="noreferrer">
                  {t("COMMON_HOME")}
                   </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  title={t("AUTH_NAV_TWITTER_TITLE")}
                  href="https://x.com/yosdanismanim"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="zmdi zmdi-twitter"></i>
                  {/* <p className="d-lg-none d-xl-none">{t("COMMON_SOCIAL_TWITTER")}</p> */}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  title={t("AUTH_NAV_YOUTUBE_TITLE")}
                  href="https://www.youtube.com/@yosdanismanim"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="zmdi zmdi-youtube"></i>
                  {/* <p className="d-lg-none d-xl-none">{t("COMMON_SOCIAL_YOUTUBE")}</p> */}
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  title={t("AUTH_NAV_INSTAGRAM_TITLE")}
                  href="https://www.instagram.com/yosdanismanim/?igsh=MTZ4cTB3ejBwcDVqbg%3D%3D#"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="zmdi zmdi-instagram"></i>
                  {/* <p className="d-lg-none d-xl-none">{t("COMMON_SOCIAL_INSTAGRAM")}</p> */}
                </a>
              </li>
              <li className="nav-item" >
                <div className="navbar-lang-switcher" style={{ marginTop:13,marginLeft:5 }}>
                  <LanguageSwitcher/>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="page-header">
        <div
          className="page-header-image"
          style={{ backgroundImage: "url(/assets/images/login.jpg)" }}
        ></div>
        <div className="container">
          <div className="col-md-12 content-center">
            <div className="card-plain">
              <form className="form" onSubmit={handleSubmit}>
                <div className="header">
                  <div className="logo-container">
                    <img src="https://www.yosdanismanim.com/wp-content/uploads/2025/11/yos-logo.png" alt="YÖS Portal" />
                  </div>
                  <h5>{t("AUTH_LOGIN_TITLE")}</h5>
                </div>

                <div className="content">
                  <Input
                    type="email"
                    name="email"
                    value={credentials.email}
                    onChange={handleChange}
                    placeholder={t("AUTH_FORM_EMAIL")}
                    icon="zmdi zmdi-account-circle"
                    required
                    validationRegex={ValidationPatterns.EMAIL}
                    errorMessage={ValidationMessages.EMAIL}
                    onValidationChange={handleValidationChange}
                  />

                  <Input
                    type="password"
                    name="password"
                    value={credentials.password}
                    onChange={handleChange}
                    placeholder={t("AUTH_FORM_PASSWORD")}
                    showPasswordToggle
                    icon="zmdi zmdi-lock"
                    required
                    validationRegex={ValidationPatterns.PASSWORD_MIN}
                    errorMessage={ValidationMessages.PASSWORD_MIN}
                    onValidationChange={handleValidationChange}
                  />
                </div>

                <div className="footer text-center">
                  <button type="submit" className="btn btn-warning btn-round btn-lg btn-block" onClick={handleSubmitLogin}>
                    {t("AUTH_LOGIN_SUBMIT")}
                  </button>
                  <div className="auth-links fontweight500" >
                    <Link to="/auth/forgot-password" className="link">
                      {t("AUTH_LOGIN_FORGOT_PASSWORD")}
                    </Link>
                    <span className="separator">•</span>
                    <Link to="/auth/register" className="link">
                      {t("AUTH_LOGIN_REGISTER")}
                    </Link>
                  </div>
                </div>
               </form>
            </div>
          </div>
        </div>

        <footer className="footer">
          <div className="container">
            <nav>
              <ul>
                <li>
                  <a href="https://www.yosdanismanim.com/iletisim/" target="_blank" rel="noreferrer">
                    {t("AUTH_FOOTER_CONTACT")}
                  </a>
                </li>
                <li>
                  <a href="https://www.yosdanismanim.com/tarihce/" target="_blank" rel="noreferrer">
                    {t("AUTH_FOOTER_ABOUT")}
                  </a>
                </li>
                <li>
                  <a href="#sss">{t("AUTH_FOOTER_FAQ")}</a>
                </li>
              </ul>
            </nav>
            <div className="copyright">
              &copy; {new Date().getFullYear()},{" "}
              <span>
                <a className="text-warning" href="http://algoraft.com/" target="_blank" rel="noreferrer">
                Algoraft.com
                </a>
                &nbsp;{t("AUTH_FOOTER_DESIGNED_BY")}{" "}
              </span>
            </div>
          </div>
        </footer>
      </div>
    </section>
  );
};

export default Login;